<template>
  <label
    :class="!prevSelected && example.remain_num === 0 ? 'NCACroa_radio_off' : null"
  >
    <input
      ref="radio"
      type="radio"
      class="amw-global-radio"
      :name="`activity-radio-${unique}`"
      :value="example.se_code"
      @change="selectActivity"
      :checked="checked"
      :disabled="!prevSelected && example.remain_num === 0"
    />
    <span class="amw-radio-overlay"></span>
    <span class="amw-label-radio-text">
      {{ display_text }}
      <em v-if="example.remain_num !== null">(잔여 {{ example.remain_num }})</em>
    </span>
  </label>
</template>

<script>
import { SURVEY, SET_QUESTION_ANSWER } from '@/store/actions/survey'
import { mapState } from 'vuex'

export default {
  name: 'SurveyExample',
  props: {
    example: {
      type: Object,
      required: true
    },
    attendant: {
      type: Object,
      required: true
    },
    resIdx: {
      type: Number,
      required: true
    },
    prevSelected: {
      type: Boolean,
      required: true
    },
    unique: {
      type: String,
      required: true,
    }
  },
  computed: {
    ...mapState(SURVEY, {
      mode: state => state.mode
    }),
    display_text() {
      return this.example.display_text;
    },
    checked() {
      return this.attendant.questions[this.example.sq_code].se_code === this.example.se_code;
    },
  },
  methods: {
    selectActivity() {
      this.$store.commit(`${SURVEY}/${SET_QUESTION_ANSWER}`, { idx: this.resIdx, sq_code: this.example.sq_code, se_code: this.example.se_code });
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/survey/components/SurveyExample.vue